import {Component, Input} from '@angular/core';
import {EddlDownloadAttemptEvent} from '@app/services/analytics/EDDL/events/eddl-download-attempt-event';
import {EventService} from '@spartacus/core';
import {EddlDownloadSuccessEvent} from '@app/services/analytics/EDDL/events/eddl-download-success-event';

@Component({
  selector: 'dcp-product-type-display',
  templateUrl: './product-type-display.component.html',
})
export class ProductTypeDisplayComponent {

  @Input() type: string;
  @Input() value: string;

  constructor(
    private eventService: EventService) {
  }

  public triggerEddlDownloadAttemptEvent(): void {
    if (this.value?.includes('.pdf')) {
      const event = new EddlDownloadAttemptEvent();
      event.url = this.value;
      setTimeout(() => this.eventService.dispatch(event));
    }
  }

  public triggerEddlDownloadSuccessEvent(): void {
    if (this.value?.includes('.pdf')) {
      const event = new EddlDownloadSuccessEvent();
      event.url = this.value;
      setTimeout(() => this.eventService.dispatch(event));
    }
  }
}
